import { ComponentEx, translate } from "../../../controls/ComponentEx";
import github from "../../../util/github";
import { log } from "../../../util/log";
import MainPage from "../../../views/MainPage";
import * as fs from "fs";
import I18next from "i18next";
import * as path from "path";
import * as React from "react";
import { Image, Media, Panel } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import { getApplication } from "../../../util/application";
import getVortexPath from "../../../util/getVortexPath";
import { getErrorMessageOrDefault } from "@vortex/shared";
let modules = {};
let ownLicenseText = "";
if (process.type === "renderer") {
    try {
        const modulesPath = path.join(getVortexPath("assets"), "modules.json");
        modules = JSON.parse(fs.readFileSync(modulesPath, { encoding: "utf8" }));
        ownLicenseText = fs
            .readFileSync(path.join(getVortexPath("package_unpacked"), "LICENSE.md"))
            .toString();
    }
    catch (err) {
        // should we display this in the ui? It shouldn't ever happen in the release and 99% of users
        // won't care anyway.
        log("error", "failed to read license files", getErrorMessageOrDefault(err));
    }
}
class AboutPage extends ComponentEx {
    mMounted;
    mVersion;
    constructor(props) {
        super(props);
        this.mMounted = false;
        this.initState({
            selectedLicense: undefined,
            licenseText: undefined,
            ownLicense: false,
            releaseDate: undefined,
            changelog: undefined,
            tag: undefined,
        });
        this.mVersion = getApplication().version;
    }
    componentDidMount() {
        this.mMounted = true;
        // no longer have to ignore if development now that we have tag information as part of the package.json version
        // this code hasn't changed, but we only show the date now next to version and not the changelog or tag
        github
            .releases()
            .then((releases) => {
            if (this.mMounted) {
                try {
                    const thisVersion = "v" + this.mVersion;
                    const thisRelease = releases.find((rel) => rel.tag_name === thisVersion);
                    if (thisRelease !== undefined) {
                        this.nextState.releaseDate = new Date(thisRelease.published_at);
                        this.nextState.changelog = thisRelease.body;
                        this.nextState.tag = thisRelease.prerelease ? "Beta" : undefined;
                    }
                    else {
                        // no release found on github, so it's packaged but not distributed properly yet
                        // this could be on the mystery Next repo for testing
                        this.nextState.tag = "Preview";
                    }
                }
                catch (err) {
                    log("warn", "Failed to parse release info", getErrorMessageOrDefault(err));
                }
            }
        })
            .catch((err) => {
            log("warn", "Failed to look up current Vortex releases", getErrorMessageOrDefault(err));
        });
    }
    componentWillUnmount() {
        this.mMounted = false;
    }
    render() {
        const { t } = this.props;
        const { changelog, ownLicense, tag, releaseDate } = this.state;
        const moduleList = Object.keys(modules).map((key) => ({
            key,
            ...modules[key],
        }));
        const imgPath = path.resolve(getVortexPath("assets"), "images", "vortex.png");
        let body = null;
        const licenseBox = ownLicense ? (React.createElement(ReactMarkdown, { className: "license-text-own", disallowedElements: ["link"] }, ownLicenseText)) : (React.createElement("div", { className: "third-party-box" },
            React.createElement("div", null,
                React.createElement("h4", null, t("Third-party libraries"))),
            React.createElement("div", { className: "about-panel" }, moduleList.map(this.renderModule))));
        const PanelX = Panel;
        body = (React.createElement(MainPage.Body, { id: "about-dialog" },
            React.createElement(Panel, null,
                React.createElement(PanelX.Body, null,
                    React.createElement(Media, { style: { marginBottom: 5, display: "block" } },
                        React.createElement(Media.Left, null,
                            React.createElement(Image, { className: "vortex-logo", src: imgPath })),
                        React.createElement(Media.Body, null,
                            React.createElement("h2", { className: "media-heading" },
                                "Vortex ",
                                this.mVersion,
                                " ",
                                releaseDate !== undefined
                                    ? `(${releaseDate.toLocaleDateString(I18next.language)})`
                                    : ""),
                            React.createElement("p", null, "\u00A92026 Black Tree Gaming Ltd."),
                            React.createElement("p", null,
                                t("Released under"),
                                " ",
                                React.createElement("a", { onClick: this.showOwnLicense }, "GPL-3"),
                                " ",
                                t("License")))),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Electron"),
                        " ",
                        process.versions.electron),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Node"),
                        " ",
                        process.versions.node),
                    React.createElement("p", null,
                        React.createElement("strong", null, "Chrome"),
                        " ",
                        process.versions.chrome),
                    licenseBox))));
        return React.createElement(MainPage, null, body);
    }
    showOwnLicense = () => {
        this.nextState.ownLicense = !this.state.ownLicense;
    };
    selectLicense = (evt) => {
        const { t } = this.props;
        const modKey = evt.currentTarget.href.split("#")[1];
        if (this.state.selectedLicense === modKey) {
            this.nextState.selectedLicense = undefined;
            return;
        }
        this.nextState.selectedLicense = modKey;
        const mod = modules[modKey];
        const license = typeof mod.licenses === "string" ? mod.licenses : mod.licenses[0];
        const licenseFile = mod.licenseFile !== undefined
            ? path.resolve(getVortexPath("modules"), "..", ...mod.licenseFile)
            : path.join(getVortexPath("assets"), "licenses", license + ".md");
        fs.readFile(licenseFile, {}, (err, licenseText) => {
            if (!this.mMounted) {
                return;
            }
            if (err !== null) {
                this.nextState.licenseText = t("Missing license {{licenseFile}}", {
                    replace: { licenseFile },
                });
            }
            else {
                this.nextState.licenseText = licenseText.toString();
            }
        });
    };
    renderModule = (mod) => {
        const { t } = this.props;
        const { licenseText, selectedLicense } = this.state;
        const licenseBox = mod.key !== selectedLicense ? null : (React.createElement(ReactMarkdown, { className: "license-text", disallowedElements: ["link"] }, licenseText || ""));
        return (React.createElement("div", { key: mod.key },
            React.createElement("h5", { style: { display: "inline" } },
                mod.name,
                " (",
                mod.version,
                ")"),
            " ",
            React.createElement("h6", { style: { display: "inline" } },
                React.createElement("sup", null,
                    React.createElement("a", { href: `#${mod.key}`, onClick: this.selectLicense },
                        mod.licenses,
                        " ",
                        t("License")))),
            licenseBox));
    };
}
export default translate(["common"])(AboutPage);
